export default "__VITE_ASSET__DCdh8XYG__"